<!-- Failed Records Table Only -->
<div *ngIf="showFailedRecords && failedRecords.length > 0">

    <div class="table-container"
        style="max-height: 400px; overflow: auto; border: 1px solid #e0e0e0; border-radius: 4px;">
        <table mat-table [dataSource]="failedRecords" class="w-full" style="width: 100%;">

            <!-- WhatsApp Number Column -->
            <ng-container [matColumnDef]="typeText">
                <th mat-header-cell *matHeaderCellDef
                    style="font-weight: 600; background-color: #f5f5f5; padding: 12px;">{{typeText}}</th>
                <td mat-cell *matCellDef="let record" style="padding: 12px;">
                    {{ record.key || 'N/A' }}
                </td>
            </ng-container>

            <!-- Reason/Message Column -->
            <ng-container matColumnDef="reason">
                <th mat-header-cell *matHeaderCellDef
                    style="font-weight: 600; background-color: #f5f5f5; padding: 12px;">Failed Message</th>
                <td mat-cell *matCellDef="let record" style="padding: 12px;">
                    <span style="color: #f44336; font-weight: 500;">
                        {{ record.reason || record.message || 'Already Exists In This Group' }}
                    </span>
                </td>
            </ng-container>


            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;" style="cursor: default;"></tr>
        </table>
        <div style="padding: 20px;" fxLayoutAlign="center center" *ngIf="failedRecords?.length === 0">
            No records found
        </div>

    </div>
</div>

<div fxLayout="row" fxLayoutAlign.gt-md="end center" fxLayoutAlign.lt-md="start center" fxLayoutGap="10px"
    style="margin-top: 24px;">
    <!-- <button [attr.guide]="'success-falure-btn-1' + '__' + sanitizeUrl(url)" ngStyle.lt-sm="width: 100%;" (click)="goToProductPage()" mat-raised-button color="primary">Done</button> -->
</div>